interface IMedalliaApi {
	loadForm: (id: string) => boolean
	showForm: (id: string) => boolean
	openForm: (id: string) => boolean
}

const MedalliaApi = (): IMedalliaApi => {
	const medalliaSdk = window["KAMPYLE_ONSITE_SDK" as any] as any
	if (!medalliaSdk) {
		console.warn("Medallia is not load")
		return MedalliaApiEmpty()
	}

	const loadForm = (id: string): boolean => medalliaSdk.loadForm(id)

	const showForm = (id: string): boolean => medalliaSdk.showForm(id)

	const openForm = (id: string): boolean => loadForm(id) && showForm(id)

	return {
		loadForm,
		showForm,
		openForm,
	}
}

const MedalliaApiEmpty = (): IMedalliaApi => {
	return {
		loadForm: () => false,
		showForm: () => false,
		openForm: () => false,
	}
}
export default MedalliaApi
